module.exports = __webpack_public_path__ + "img/battletrip_section5_left.ca83173c.png";